import '../styles/globals.css'
import Layout from '../components/Layout'
import 'mdb-react-ui-kit/dist/css/mdb.rtl.min.css'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import React, { useEffect } from 'react'
import LoadingPageChages from '../components/Elements/Loading/LoadingPageChages'
import { clarity } from 'react-microsoft-clarity'
import ErrorBoundary from '../components/ErrorBoundry'
import TagManager from 'react-gtm-module'

function MyApp ({ Component, pageProps }) {
  useEffect(() => {
    TagManager.initialize({ gtmId: 'GTM-N85BQZD9' })
  }, [])

  useEffect(() => {
    clarity.init('ghwibrmhxr')
  }, [])

  return (
    <>
      <Layout>
        <ErrorBoundary>
          <Component {...pageProps} />
        </ErrorBoundary>
      </Layout>
      <LoadingPageChages />
    </>
  )
}

export default MyApp
